import { API_URLS } from "../../constants/api/index.js"
async function CompositeChangePassword({id ,entry,userId,password,mail,phone}) {

   let responseData: { retCode: number, retMsg: string, refId:string } = {
      retCode: 99,
      retMsg: "",
      refId:""
   }
   const data = `{
         "id": "${id}",
         "entry":"${entry}",
         "userId": "${userId}",
         "mail": "${mail}",
         "phone": "${phone}",
         "password": "${password}"
   }`;

//https://azure-apigateway-openbanking-uat.apps.ocptest4.akbank.com/api/v1/ldapaccessbase/change-password-ad
 
   await fetch(
   API_URLS.COMPOSITE2,
      { method: "POST", body: data }
  ).then(response => response.json())
      .then((textResponse) => {  
         debugger;
          debugger;
          responseData = {
            retCode: textResponse.retCode,           
             retMsg: textResponse.retMsg,
             refId:textResponse.refId
          };
      })
      .catch((error) => {
        
      })
  return responseData;
}

export { CompositeChangePassword }


